import { AfterViewInit, Component, QueryList, ViewChild, ContentChild, ElementRef, AfterContentChecked, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgIconComponent } from '@ng-icons/core';
import { QuestionComponent } from '../../question/question/question.component';
import { lastValueFrom, timer, take } from 'rxjs';
import { NgTemplateOutlet } from '@angular/common';

@Component({
    selector: 'app-test',
    imports: [],
    templateUrl: './test.component.html',
    styleUrl: './test.component.scss'
})
export class TestComponent {  
  @ViewChild('fadediv', { read: ElementRef })
  fadediv!: ElementRef<HTMLDivElement>;

  @Input()
  public title?: string;

  async fadeOut(): Promise<void> {
    this.fadediv.nativeElement.style.opacity = '0';
    await lastValueFrom(timer(500).pipe(take(1)));
  }

  async fadeIn(): Promise<void> {
    this.fadediv.nativeElement.style.opacity = '100';
    await lastValueFrom(timer(500).pipe(take(1)));
  }
}
